<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    JSON Import/Export
    <i class="material-icons" #closebtn data-bs-dismiss="modal" (click)='close()'>close</i>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    @if (errMessage && !selectedFile) {
      <p class="text-danger">
        {{errMessage}}
      </p>
    }
    <!-- of {{languageData.Name}} verion -->
    <span>
      Click the button below to Download or Upload the latest JSON file format of {{languageData.name}}
      version.
    </span>
    <div class="text-center" style="margin-top: 10px;">
      <button class=" btn btn__btn-default btn__orange mar-rig-10" (click)="downloadJsonData(defaultLanguageId, 'Original')">
        <i class="material-icons icon-class">
          cloud_download
        </i>
        Download Original
      </button>
      <button class=" btn btn__btn-default btn__orange mar-rig-10" (click)="downloadJsonData(languageData.id, languageData.name)">
        <i class="material-icons icon-class">
          cloud_download
        </i>
        Download {{languageData.name}}
      </button>
      <span class="upload-btn-wrapper" style=" bottom: -19px;">
        <button class="btn btn__btn-default btn__orange mar-rig-10">
          <i class="material-icons icon-class">
            cloud_upload
          </i>
          Upload
        </button>
        <input class="uploadResource btn btn-primary" id="allbutton-style" type="file" #fileInputJson
          (click)="clearResource()" value="" (change)="fileChangeEvent($event, jsonAllowedExtensions)" />
      </span>
    </div>
    <div class="text-center upload-file-name" style="margin-top: 10px;">
      @if (selectedFile) {
        <li class="inline-label-overflow-container">
          <label for="File" class="" style="margin-bottom: 0; line-height: 38px; margin-right: 15px;"> <span>Selected
          File</span></label>
          <span class="resource-title file-title" title="">{{selectedFile.name}}</span>
        </li>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal" (click)='close()'>Cancel</button>
    <button id="editImageModalSaveBtnId" class="btn btn__btn-default btn__orange mr-top-1" [disabled]="!selectedFile"
    [ngClass]="{'custom-btn-disabled': !selectedFile}" (click)="save()">Save</button>
  </div>
</div>
